import { Recipe } from "./types";

// Desserts Recipes - Single source of truth for all desserts descriptions
export const dessertsRecipes: Record<string, Recipe> = {
  baklava: {
    id: "baklava",
    name: "Baklava",
    nameFr: "Baklava",
    nameKey: "recipes.baklava.name",
    description:
      "A traditional layered pastry made with crisp phyllo dough, finely chopped nuts, and warm aromatic spices, finished with a sweet honey syrup for a rich, decadent treat",
    descriptionFr:
      "Un dessert traditionnel composé de fines couches de pâte phyllo croustillante, de noix finement hachées et d'épices parfumées, le tout nappé d'un sirop au miel pour une douceur riche et décadente",
    descriptionKey: "recipes.baklava.description",
  },

  jello: {
    id: "jello",
    name: "Jell-O",
    nameFr: "Jell-O",
    nameKey: "recipes.jello.name",
    description:
      "A refreshing, classic gelatin dessert served chilled, light, and gently sweet, a simple and nostalgic finish to any meal",
    descriptionFr:
      "Un dessert gélatineux classique et rafraîchissant, servi bien froid, léger et délicatement sucré, une touche nostalgique et parfaite pour terminer le repas",
    descriptionKey: "recipes.jello.description",
  },

  "caramel-custard": {
    id: "caramel-custard",
    name: "Caramel Custard",
    nameFr: "Crème caramel",
    nameKey: "recipes.caramelCustard.name",
    description:
      "A silky baked custard topped with a smooth, golden caramel glaze. Light, elegant, and timeless",
    descriptionFr:
      "Un flan onctueux cuit au four, nappé d’un caramel doré et velouté. Léger, élégant et intemporel",
    descriptionKey: "recipes.caramelCustard.description",
  },

  "cake-of-the-day": {
    id: "cake-of-the-day",
    name: "Cake of the Day",
    nameFr: "Gâteau du jour",
    nameKey: "recipes.cakeOfTheDay.name",
    description:
      "A freshly prepared daily cake, crafted with seasonal ingredients and rotating flavors",
    descriptionFr:
      "Un gâteau préparé chaque jour avec des ingrédients de saison et des saveurs variées",
    descriptionKey: "recipes.cakeOfTheDay.description",
  },

  "pouding-chomeur": {
    id: "pouding-chomeur",
    name: "Pouding Chômeur",
    nameFr: "Pouding chômeur",
    nameKey: "recipes.poudingChomeur.name",
    description:
      "A classic Quebec dessert featuring a tender vanilla cake baked in a warm, rich maple syrup and brown sugar sauce. Comforting and indulgent",
    descriptionFr:
      "Un classique québécois composé d’un gâteau moelleux à la vanille, cuit dans une sauce chaude au sirop d'érable et au sucre brun. Réconfortant et gourmand",
    descriptionKey: "recipes.poudingChomeur.description",
  },

  "rice-pudding": {
    id: "rice-pudding",
    name: "Rice Pudding",
    nameFr: "Pouding au riz",
    nameKey: "recipes.ricePudding.name",
    description:
      "Creamy, slow-cooked rice blended with milk, vanilla, and a hint of warm spices for a comforting and traditional dessert",
    descriptionFr:
      "Un pouding crémeux préparé lentement avec du riz, du lait, de la vanille et une touche d’épices chaudes pour un dessert réconfortant et traditionnel",
    descriptionKey: "recipes.ricePudding.description",
  },

  "ice-cream": {
    id: "ice-cream",
    name: "Ice Cream",
    nameFr: "Crème glacée",
    nameKey: "recipes.iceCream.name",
    description:
      "A classic scoop of smooth, creamy ice cream, simple, refreshing, and always satisfying",
    descriptionFr:
      "Une boule classique de crème glacée onctueuse et crémeuse, simple, rafraîchissante et toujours appréciée",
    descriptionKey: "recipes.iceCream.description",
  },

  galaktoboureko: {
    id: "galaktoboureko",
    name: "Galaktoboureko",
    nameFr: "Galaktoboureko",
    nameKey: "recipes.galaktoboureko.name",
    description:
      "A traditional Greek custard dessert featuring creamy semolina filling wrapped in buttery phyllo and finished with a fragrant citrus syrup.",
    descriptionFr:
      "Un dessert grec traditionnel composé d’une crème semoule onctueuse enveloppée dans une pâte phyllo beurrée et nappée d’un sirop parfumé aux agrumes.",
    descriptionKey: "recipes.galaktoboureko.description",
  },

  "creme-caramel": {
    id: "creme-caramel",
    name: "Crème Caramel",
    nameFr: "Crème caramel",
    nameKey: "recipes.cremeCaramel.name",
    description:
      "A silky, oven-baked custard topped with a smooth, amber caramel glaze for a refined and timeless dessert.",
    descriptionFr:
      "Un flan onctueux cuit au four, nappé d’un caramel ambré et soyeux pour un dessert élégant et intemporel.",
    descriptionKey: "recipes.cremeCaramel.description",
  },
};
